export const AdaptiveTestStatus = {
  completed: "completed",
  started: "started",
};

export type LevelTestResponseType = {
  question: {
    text: string;
  };
  test: {
    evaluated_level: { value: number };
    answer_options: { text: string; id: string }[];
  };
};
